import {colors} from "@c10h/colors";
import {withStyles} from "@material-ui/core/styles";
import MaterialTooltip from "@material-ui/core/Tooltip";
import React from "react";

export const Tooltip = withStyles(() => ({
  tooltip: {
    backgroundColor: colors.gray600,
    maxWidth: "15rem",
    fontSize: "12px",
    padding: ".5rem 1rem",
  },
  arrow: {
    color: colors.gray600,
    marginBottom: "-6px !important",
  },
}))(({classes, ...props}: any) => (
  <MaterialTooltip
    classes={{
      tooltip: classes.tooltip,
      arrow: classes.arrow,
    }}
    {...props}
  />
));

export default Tooltip;
